// import React from "react";
// import { SmartReportContent } from "../Components/SmartReportContent";

// const SmartReport = () => {
//   return <SmartReportContent />;
// };

// export default SmartReport;
import React from "react";
import { getSEOData } from "../../../../global/utils/constants/seoConfig";
import SEO from "../../../../global/components/SEO/SEO";
import { SmartReportContent } from "../Components/SmartReportContent";

const SmartReport = () => {
  const seoData = getSEOData("/smart-report");

  return (
    <>
      <SEO
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        type="website"
      />
      <SmartReportContent />
    </>
  );
};

export default SmartReport;